import backendUrl from "./backendUrl";

export const wishlistApi = {
  addToWishlist: {
    url: `${backendUrl}/api/add-to-wishlist`,
    method: "post",
  },
  removeFromWishlist: {
    url: `${backendUrl}/api/remove-from-wishlist`,
    method: "delete",
  },
  getWishlist: {
    url: `${backendUrl}/api/get-wishlist`,
    method: "get",
  },
  checkWishlist: {
    url: `${backendUrl}/api/check-wishlist`,
    method: "get",
  },
};
